import type { FC } from 'react';

/**
 * Opaque guard over the top safe area (status bar / notch).
 *
 * The global `#root { padding-top: env(safe-area-inset-top) }` only offsets the
 * initial layout: because that padding is part of the scrolled content, it
 * scrolls away with the content, letting page content slide under iOS's
 * transparent overlay status bar (viewport-fit=cover). This fixed bar masks
 * that region so content never visually overlaps the clock, mirroring how
 * BottomNav guards the bottom safe area. Collapses to 0 height on devices and
 * browsers without a top inset.
 */
export const SafeAreaTop: FC = () => (
  <div
    aria-hidden
    className='pointer-events-none fixed inset-x-0 top-0 z-40 bg-background'
    style={{ height: 'env(safe-area-inset-top)' }}
  />
);

export default SafeAreaTop;
